require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-project-euler-problem-450-hypocycloid-and-lattice-points.json") })
        }
      }, "path---coding-interview-prep-project-euler-problem-450-hypocycloid-and-lattice-points");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-project-euler-problem-450-hypocycloid-and-lattice-points!./.cache/json/coding-interview-prep-project-euler-problem-450-hypocycloid-and-lattice-points.json
// module id = 1738
// module chunks = 231608221292675